import {
  IDefaultTableColumnConfig,
  IDigitalRetailingOverviewBillboardConfig,
  IDigitalRetailingOverviewConfig,
  IDualAxisLineGraphConfig,

  IMultiLevelDualAxisLineGraphConfig
} from '../../../../_shared/models/models-index';
import * as constants from '../../../../_shared/constants/constants';
import { Enums } from '../../../../_shared/enums/enums';

export class DigitalRetailingOverviewConfig implements IDigitalRetailingOverviewConfig {
  public useV5 = false;
  public reportTitle = 'Digital Retailing Overview';
  public useDefaultComparisonColumns = true;
  public metricDisplayModes = [
    { name: 'MOM', value: 'MOM' },
    { name: 'YOY', value: 'YOY' }
  ];
  public dealerTableLabel = 'Dealer Summary';
  public showEngagementAnalysis = false;
  public chartSeriesColors = ['#384752', '#52616C', '#05141F'];
  public billboards: IDigitalRetailingOverviewBillboardConfig[] = [{
    title: 'Session Start Rate',
    subtitle: null,
    iconClass: 'fa-users fa-primary',
    reverseMetric: false,
    metricCurrentPropertyName: 'sessionStartRate',
    metricMOMPropertyName: 'sessionStartRateMOM',
    metricYOYPropertyName: 'sessionStartRateYOY',
    metricPreviousMonthPropertyName: 'sessionStartRatePreviousMonth',
    metricPreviousMTDPropertyName: 'sessionStartRatePreviousMTD',
    metricPreviousMTDDisplayOnCurrentMonth: true,
    metricPreviousMTDDisplayHistorical: false,
    metricPreviousMTDLabel: 'Prev. MTD',
    metricPreviousMonthDisplayOnCurrentMonth: true,
    metricPreviousMonthDisplayHistorical: true,
    metricPreviousMonthLabel: 'Prev. Month',
    metricPreviousYearPropertyName: null,
    footerRowCount: 1,
    footerTwoLeftLabel: 'MOM',
    footerTwoRightLabel: 'YOY',
    footerTwoMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
    showTrendArrow: true,
    trendArrowDrivingPropertyName: 'sessionStartRateMOM',
    metricFormatKey: constants.formatKeys.percentageTwoDecimals,
    helpTextKey: 'DigitalRetailingOverviewSessionStartRateBillboardHelp',
    helpTextTitle: 'Session Start Rate',
  }, {
    title: 'Payment Calc Rate',
    subtitle: null,
    iconClass: 'fa-calculator fa-primary',
    reverseMetric: false,
    metricCurrentPropertyName: 'paymentCalcRate',
    metricMOMPropertyName: 'paymentCalcRateMOM',
    metricYOYPropertyName: 'paymentCalcRateYOY',
    metricPreviousMonthPropertyName: 'paymentCalcRatePreviousMonth',
    metricPreviousMTDPropertyName: 'paymentCalcRatePreviousMTD',
    metricPreviousMTDDisplayOnCurrentMonth: true,
    metricPreviousMTDDisplayHistorical: false,
    metricPreviousMTDLabel: 'Prev. MTD',
    metricPreviousMonthDisplayOnCurrentMonth: true,
    metricPreviousMonthDisplayHistorical: true,
    metricPreviousMonthLabel: 'Prev. Month',
    metricPreviousYearPropertyName: null,
    footerRowCount: 1,
    footerTwoLeftLabel: 'MOM',
    footerTwoRightLabel: 'YOY',
    footerTwoMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
    showTrendArrow: true,
    trendArrowDrivingPropertyName: 'paymentCalcRateMOM',
    metricFormatKey: constants.formatKeys.percentageTwoDecimals,
    helpTextKey: 'DigitalRetailingOverviewPaymentCalcRateBillboardHelp',
    helpTextTitle: 'Payment Calc Rate',
  }, {
    title: 'Lead Capture Rate',
    subtitle: null,
    iconClass: 'fa-user-circle fa-primary',
    reverseMetric: false,
    metricCurrentPropertyName: 'leadCaptureRate',
    metricMOMPropertyName: 'leadCaptureRateMOM',
    metricYOYPropertyName: 'leadCaptureRateYOY',
    metricPreviousMonthPropertyName: 'leadCaptureRatePreviousMonth',
    metricPreviousMTDPropertyName: 'leadCaptureRatePreviousMTD',
    metricPreviousMTDDisplayOnCurrentMonth: true,
    metricPreviousMTDDisplayHistorical: false,
    metricPreviousMTDLabel: 'Prev. MTD',
    metricPreviousMonthDisplayOnCurrentMonth: true,
    metricPreviousMonthDisplayHistorical: true,
    metricPreviousMonthLabel: 'Prev. Month',
    metricPreviousYearPropertyName: null,
    footerRowCount: 1,
    footerTwoLeftLabel: 'MOM',
    footerTwoRightLabel: 'YOY',
    footerTwoMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
    showTrendArrow: true,
    trendArrowDrivingPropertyName: 'leadCaptureRateMOM',
    metricFormatKey: constants.formatKeys.percentageTwoDecimals,
    helpTextKey: 'DigitalRetailingOverviewLeadCaptureRateBillboardHelp',
    helpTextTitle: 'Lead Capture Rate',
  }, {
    title: 'Appointment Rate',
    subtitle: null,
    iconClass: 'fa-check-square-o fa-primary',
    reverseMetric: false,
    metricCurrentPropertyName: 'appointmentRate',
    metricMOMPropertyName: 'appointmentRateMOM',
    metricYOYPropertyName: 'appointmentRateYOY',
    metricPreviousMonthPropertyName: 'appointmentRatePreviousMonth',
    metricPreviousMTDPropertyName: 'appointmentRatePreviousMTD',
    metricPreviousMTDDisplayOnCurrentMonth: true,
    metricPreviousMTDDisplayHistorical: false,
    metricPreviousMTDLabel: 'Prev. MTD',
    metricPreviousMonthDisplayOnCurrentMonth: true,
    metricPreviousMonthDisplayHistorical: true,
    metricPreviousMonthLabel: 'Prev. Month',
    metricPreviousYearPropertyName: null,
    footerRowCount: 1,
    footerTwoLeftLabel: 'MOM',
    footerTwoRightLabel: 'YOY',
    footerTwoMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
    showTrendArrow: true,
    trendArrowDrivingPropertyName: 'appointmentRateMOM',
    metricFormatKey: constants.formatKeys.percentageTwoDecimals,
    helpTextKey: 'DigitalRetailingOverviewAppointmentRateBillboardHelp',
    helpTextTitle: 'Appointment Rate',
  }];
  public kpiSheetOptions = {
    overview: [{
      name: 'providerId',
      label: 'Provider',
      isHeader: true
    }, {
      name: 'uniqueShoppers',
      label: 'Unique Shoppers',
    }, {
      name: 'leadCaptureRate',
      label: 'Lead Capture Rate',
      format: constants.formatKeys.percentageTwoDecimals
    }, {
      name: 'paymentCalcRate',
      label: 'Payment Calc Rate',
      format: constants.formatKeys.percentageTwoDecimals
    }, {
      name: 'tradeInRate',
      label: 'Trade-In Rate',
      format: constants.formatKeys.percentageTwoDecimals
    }, {
      name: 'allCreditAppRate',
      label: 'All Credit App Rate',
      format: constants.formatKeys.percentageTwoDecimals
    }, {
      name: 'appointmentRate',
      label: 'Appointment Rate',
      format: constants.formatKeys.percentageTwoDecimals
    }]
  };
  public trendGraphConfig: IMultiLevelDualAxisLineGraphConfig = {
    xAxisPropertyName: 'date',
    parentMetrics: [
      {
        id: Enums.digitalRetailingMetrics.sessionStarts.metricId,
        displayName: Enums.digitalRetailingMetrics.sessionStarts.name,
        propertyName: Enums.digitalRetailingMetrics.sessionStarts.nameKey,
        metricFormatKey: constants.formatKeys.localeString
      },
      {
        id: Enums.digitalRetailingMetrics.sessionStartRate.metricId,
        displayName: Enums.digitalRetailingMetrics.sessionStartRate.name,
        propertyName: Enums.digitalRetailingMetrics.sessionStartRate.nameKey,
        metricFormatKey: constants.formatKeys.percentageTwoDecimals
      },
      {
        id: Enums.digitalRetailingMetrics.uniqueShoppers.metricId,
        displayName: Enums.digitalRetailingMetrics.uniqueShoppers.name,
        propertyName: Enums.digitalRetailingMetrics.uniqueShoppers.nameKey,
        metricFormatKey: constants.formatKeys.localeString
      },
      {
        id: Enums.digitalRetailingMetrics.visits.metricId,
        displayName: Enums.digitalRetailingMetrics.visits.name,
        propertyName: Enums.digitalRetailingMetrics.visits.nameKey,
        metricFormatKey: constants.formatKeys.localeString
      },
      {
        id: Enums.digitalRetailingMetrics.visitors.metricId,
        displayName: Enums.digitalRetailingMetrics.visitors.name,
        propertyName: Enums.digitalRetailingMetrics.visitors.nameKey,
        metricFormatKey: constants.formatKeys.localeString
      },
      {
        id: Enums.digitalRetailingMetrics.paymentCalculators.metricId,
        displayName: Enums.digitalRetailingMetrics.paymentCalculators.name,
        propertyName: Enums.digitalRetailingMetrics.paymentCalculators.nameKey,
        metricFormatKey: constants.formatKeys.localeString
      },
      {
        id: Enums.digitalRetailingMetrics.paymentCalculatorRate.metricId,
        displayName: Enums.digitalRetailingMetrics.paymentCalculatorRate.name,
        propertyName: Enums.digitalRetailingMetrics.paymentCalculatorRate.nameKey,
        metricFormatKey: constants.formatKeys.percentageTwoDecimals
      },
      {
        id: Enums.digitalRetailingMetrics.tradeIns.metricId,
        displayName: Enums.digitalRetailingMetrics.tradeIns.name,
        propertyName: Enums.digitalRetailingMetrics.tradeIns.nameKey,
        metricFormatKey: constants.formatKeys.localeString
      },
      {
        id: Enums.digitalRetailingMetrics.tradeInRate.metricId,
        displayName: Enums.digitalRetailingMetrics.tradeInRate.name,
        propertyName: Enums.digitalRetailingMetrics.tradeInRate.nameKey,
        metricFormatKey: constants.formatKeys.percentageTwoDecimals
      },
      {
        id: Enums.digitalRetailingMetrics.financeFinishes.metricId,
        displayName: Enums.digitalRetailingMetrics.financeFinishes.name,
        propertyName: Enums.digitalRetailingMetrics.financeFinishes.nameKey,
        metricFormatKey: constants.formatKeys.localeString
      },
      {
        id: Enums.digitalRetailingMetrics.financeFinishRate.metricId,
        displayName: Enums.digitalRetailingMetrics.financeFinishRate.name,
        propertyName: Enums.digitalRetailingMetrics.financeFinishRate.nameKey,
        metricFormatKey: constants.formatKeys.percentageTwoDecimals
      },
      {
        id: Enums.digitalRetailingMetrics.leadCaptures.metricId,
        displayName: Enums.digitalRetailingMetrics.leadCaptures.name,
        propertyName: Enums.digitalRetailingMetrics.leadCaptures.nameKey,
        metricFormatKey: constants.formatKeys.localeString
      },
      {
        id: Enums.digitalRetailingMetrics.leadCaptureRate.metricId,
        displayName: Enums.digitalRetailingMetrics.leadCaptureRate.name,
        propertyName: Enums.digitalRetailingMetrics.leadCaptureRate.nameKey,
        metricFormatKey: constants.formatKeys.percentageTwoDecimals
      },
      {
        id: Enums.digitalRetailingMetrics.allCreditApps.metricId,
        displayName: Enums.digitalRetailingMetrics.allCreditApps.name,
        propertyName: Enums.digitalRetailingMetrics.allCreditApps.nameKey,
        metricFormatKey: constants.formatKeys.localeString
      },
      {
        id: Enums.digitalRetailingMetrics.allCreditAppRate.metricId,
        displayName: Enums.digitalRetailingMetrics.allCreditAppRate.name,
        propertyName: Enums.digitalRetailingMetrics.allCreditAppRate.nameKey,
        metricFormatKey: constants.formatKeys.percentageTwoDecimals
      },
      {
        id: Enums.digitalRetailingMetrics.preQualifieds.metricId,
        displayName: Enums.digitalRetailingMetrics.preQualifieds.name,
        propertyName: Enums.digitalRetailingMetrics.preQualifieds.nameKey,
        metricFormatKey: constants.formatKeys.localeString
      },
      {
        id: Enums.digitalRetailingMetrics.preQualifiedRate.metricId,
        displayName: Enums.digitalRetailingMetrics.preQualifiedRate.name,
        propertyName: Enums.digitalRetailingMetrics.preQualifiedRate.nameKey,
        metricFormatKey: constants.formatKeys.percentageTwoDecimals
      },
      {
        id: Enums.digitalRetailingMetrics.creditApps.metricId,
        displayName: Enums.digitalRetailingMetrics.creditApps.name,
        propertyName: Enums.digitalRetailingMetrics.creditApps.nameKey,
        metricFormatKey: constants.formatKeys.localeString
      },
      {
        id: Enums.digitalRetailingMetrics.creditAppRate.metricId,
        displayName: Enums.digitalRetailingMetrics.creditAppRate.name,
        propertyName: Enums.digitalRetailingMetrics.creditAppRate.nameKey,
        metricFormatKey: constants.formatKeys.percentageTwoDecimals
      },
      {
        id: Enums.digitalRetailingMetrics.appointments.metricId,
        displayName: Enums.digitalRetailingMetrics.appointments.name,
        propertyName: Enums.digitalRetailingMetrics.appointments.nameKey,
        metricFormatKey: constants.formatKeys.localeString
      }, {
        id: Enums.digitalRetailingMetrics.appointmentRate.metricId,
        displayName: Enums.digitalRetailingMetrics.appointmentRate.name,
        propertyName: Enums.digitalRetailingMetrics.appointmentRate.nameKey,
        metricFormatKey: constants.formatKeys.percentageTwoDecimals
      }
    ],
    childMetrics: [
      {
        id: Enums.chatProviders.allProviders.providerId,
        displayName: Enums.chatProviders.allProviders.displayName,
        propertyName: Enums.chatProviders.allProviders.name,
        metricFormatKey: constants.formatKeys.entityDisplayName
      },
      {
        id: 1,
        displayName: 'Dealer.com',
        propertyName: 'Dealer.com',
        metricFormatKey: constants.formatKeys.entityDisplayName
      },
      {
        id: 4,
        displayName: 'Dealer eProcess',
        propertyName: 'Dealer eProcess',
        metricFormatKey: constants.formatKeys.entityDisplayName
      },
      {
        id: 12,
        displayName: 'Dealer Inspire',
        propertyName: 'Dealer Inspire',
        metricFormatKey: constants.formatKeys.entityDisplayName
      },
      {
        id: 20,
        displayName: 'CarNow',
        propertyName: 'CarNow',
        metricFormatKey: constants.formatKeys.entityDisplayName
      },
      {
        id: 22,
        displayName: 'Gubagoo',
        propertyName: 'Gubagoo',
        metricFormatKey: constants.formatKeys.entityDisplayName
      },
      {
        id: 26,
        displayName: 'Roadster',
        propertyName: 'Roadster',
        metricFormatKey: constants.formatKeys.entityDisplayName
      },
      {
        id: 27,
        displayName: 'AutoFi',
        propertyName: 'AutoFi',
        metricFormatKey: constants.formatKeys.entityDisplayName
      },
      {
        id: 28,
        displayName: 'Upstart',
        propertyName: 'Upstart',
        metricFormatKey: constants.formatKeys.entityDisplayName
      },
      {
        id: 29,
        displayName: 'WebBuy',
        propertyName: 'WebBuy',
        metricFormatKey: constants.formatKeys.entityDisplayName
      },
      {
        id: 30,
        displayName: 'Darwin',
        propertyName: 'Darwin',
        metricFormatKey: constants.formatKeys.entityDisplayName
      },
    ],
    defaultChildrenIds: [Enums.chatProviders.allProviders.providerId, Enums.chatProviders.allProviders.providerId],
    defaultParentIds: [Enums.digitalRetailingMetrics.sessionStarts.metricId, Enums.digitalRetailingMetrics.appointmentRate.metricId],
    metricOneColorHexCode: '#05141F',
    metricTwoColorHexCode: '#9EA1A2'
  };
  public dealerTableColumns: IDefaultTableColumnConfig[] = [
    {
      show: true,
      header: '',
      columnDef: 'entity',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.entityDisplayName,
      clickable: true
    }, {
      show: false,
      print: true,
      header: 'Dealer Name',
      columnDef: 'displayName',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.entityDisplayName, clickable: false
    },
    // website Visits
    {
      show: true,
      header: 'Website Visits',
      columnDef: 'visits',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.localeString,
      clickable: false,
      hasComparisonMetrics: true
    },
    // website Visitors
    {
      show: true,
      header: 'Website Visitors',
      columnDef: 'visitors',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.localeString,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Session Starts
    {
      show: true,
      header: 'Session Starts',
      columnDef: 'sessionStarts',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.localeString,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Unique Shoppers
    {
      show: true,
      header: 'Unique Shoppers',
      columnDef: 'uniqueShoppers',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.localeString,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Session Start Rate
    {
      show: true,
      header: 'Session Start Rate',
      columnDef: 'sessionStartRate',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Payment Calculators
    {
      show: true,
      header: 'Payment Calculators',
      columnDef: 'paymentCalcs',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.localeString,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Payment Calculator Rate
    {
      show: true,
      header: 'Payment Calculator Rate',
      columnDef: 'paymentCalcRate',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Trade-Ins
    {
      show: true,
      header: 'Trade-Ins',
      columnDef: 'tradeIns',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.localeString,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Trade-In Rate
    {
      show: true,
      header: 'Trade-In Rate',
      columnDef: 'tradeInRate',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals,
      clickable: false,
      hasComparisonMetrics: true
    },
    // F & I Completions
    {
      show: true,
      header: 'F & I Completes',
      columnDef: 'financeFinishes',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.localeString,
      clickable: false,
      hasComparisonMetrics: true
    },
    // F & I Completions Rate
    {
      show: true,
      header: 'F & I Complete Rate',
      columnDef: 'financeFinishRate',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Lead Captures
    {
      show: true,
      header: 'Lead Captures',
      columnDef: 'leadCaptures',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.localeString,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Lead Capture Rate
    {
      show: true,
      header: 'Lead Capture Rate',
      columnDef: 'leadCaptureRate',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals,
      clickable: false,
      hasComparisonMetrics: true
    },
    // All Credit Apps
    {
      show: true,
      header: 'All Credit Apps',
      columnDef: 'allCreditApps',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.localeString,
      clickable: false,
      hasComparisonMetrics: true
    },
    // All Credit App Rate
    {
      show: true,
      header: 'All Credit Apps Rate',
      columnDef: 'allCreditAppRate',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Pre-Qualified
    {
      show: true,
      header: 'Pre-Qualified',
      columnDef: 'preQualified',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.localeString,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Pre-Qualified Rate
    {
      show: true,
      header: 'Pre-Qualified Rate',
      columnDef: 'preQualifiedRate',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Credit Apps
    {
      show: true,
      header: 'Credit Apps',
      columnDef: 'creditApps',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.localeString,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Credit App Rate
    {
      show: true,
      header: 'Credit App Rate',
      columnDef: 'creditAppRate',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Credit Apps
    {
      show: true,
      header: 'Appointments',
      columnDef: 'appointments',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.localeString,
      clickable: false,
      hasComparisonMetrics: true
    },
    // Appointment Rate
    {
      show: true,
      header: 'Appointment Rate',
      columnDef: 'appointmentRate',
      isMom: false,
      isYoy: false,
      metricFormatKey: constants.formatKeys.percentageTwoDecimals,
      clickable: false,
      hasComparisonMetrics: true
    },
  ];
}
